import { ref } from 'vue'
import { App } from '@capacitor/app'
import { useAPIURLs } from './useAPIURLs'
import { Capacitor } from '@capacitor/core'
import { useTimers } from '../store/timers'
import { storeToRefs } from 'pinia'
import { Http } from '@capacitor-community/http'
import { useFilesystem } from './filesystem'
import { Notify } from 'quasar'
import { useNetwork } from './useNetwork'

const { getStatus } = useNetwork()

const newAvailable = ref(false)
export const useCheckVersion = () => {
  const current = async () => {
    const { getInfo } = App
    return (await getInfo()).version
  }
  const checkedVersion = ref<undefined | string>()

  const { API } = useAPIURLs()
  const checkAvailable = async (options: { showWarnings: boolean } = { showWarnings: true }) => {
    //cancel these checks if browser version or a timer is running
    if (!Capacitor.isNativePlatform()) {
      return void 0
    }
    const { getActiveParentTimer } = storeToRefs(useTimers())
    if (getActiveParentTimer.value) {
      return void 0
    }
    //if no network just skip, set newAv to false since they can't download
    console.log('status', getStatus.value)
    if (!getStatus.value) {
      newAvailable.value = false
      return void 0
    }

    const res = await Http.get({
      url: API.value.checkVersion,
      connectTimeout: 60000,
      readTimeout: 60000,
    }).catch((error) => {
      if (String(error).toLowerCase().includes('sockettimeout') && options.showWarnings) {
        Notify.create({
          type: 'warning',
          timeout: 15000,
          position: 'bottom-left',
          message:
            'Failed to check for updates. Please check your internet connection and try again.',
        })
      } else if (
        String(error).toLowerCase().includes('sockettimeoutexception') &&
        options.showWarnings
      ) {
        Notify.create({
          type: 'warning',
          timeout: 10000,
          position: 'bottom-left',
          message:
            'Failed to check for updates. Please check your internet connection and try again.',
        })
      } else if (String(error).toLowerCase().includes('socketexception') && options.showWarnings) {
        Notify.create({
          type: 'warning',
          timeout: 10000,
          position: 'bottom-left',
          message:
            'Failed to check for updates. Please check your internet connection and try again.',
        })
      } else if (
        String(error).toLowerCase().includes('unknownhostexception') &&
        options.showWarnings
      ) {
        Notify.create({
          type: 'warning',
          timeout: 10000,
          position: 'bottom-left',
          message:
            'Failed to check for updates. Please check your internet connection and try again.',
        })
      } else if (String(error).toLowerCase().includes('connectexception') && options.showWarnings) {
        Notify.create({
          type: 'warning',
          timeout: 10000,
          position: 'bottom-left',
          message:
            'Failed to check for updates. Please check your internet connection and try again.',
        })
      } else if (options.showWarnings) {
        Notify.create({
          type: 'negative',
          timeout: 15000,
          position: 'bottom-left',
          message: `An error occurred checking for updates: ${error}.`,
        })
      }
      throw new Error(error)
    })
    if (res && res.data && res.data.version) {
      const currentVersion = await current()
      checkedVersion.value = res.data.version
      apkPath.value = res.data.path
      newAvailable.value = compareVersions(currentVersion, checkedVersion.value!)
    }
  }

  const apkPath = ref()
  const getAPK = async () => {
    const { fetchApk } = useFilesystem()
    if (apkPath.value) {
      await fetchApk(apkPath.value, checkedVersion.value!)
    } else {
      Notify.create({
        type: 'warning',
        timeout: 15000,
        position: 'bottom-left',
        message: 'Your connection might be weak, please try updating shortly.',
      })
      throw new Error('No APK path found')
    }
  }
  return { newAvailable, checkAvailable, getAPK }
}

const compareVersions = (current: string, target: string) => {
  const currentSemVers = current.split('.').map((item) => Number(item))
  const targetSemVers = target.split('.').map((item) => Number(item))
  console.log('current', current, 'target', target)
  //major version
  if (currentSemVers[0] < targetSemVers[0]) {
    return true
    //minor version
  } else if (currentSemVers[0] == targetSemVers[0] && currentSemVers[1] < targetSemVers[1]) {
    return true
    //patch version
  } else if (
    currentSemVers[0] == targetSemVers[0] &&
    currentSemVers[1] == targetSemVers[1] &&
    currentSemVers[2] < targetSemVers[2]
  ) {
    return true
  }

  return false
}
